import { gql } from '@apollo/client';

export const ADD_UPDATE_EXCHANGE_RATE = gql`
  mutation addOrUpdateExchangeRate($input: ExchangeRateItemInput) {
    addOrUpdateExchangeRate(input: $input) {
      commandId
      correlationId
    }
  }
`;
